import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ChevronLeft() {
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.6 18.9995L8 11.9995L14.6 4.99951",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  });
}